import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-checkbox-vehicle',
  templateUrl: './skeleton-checkbox-vehicle.component.html',
  styleUrls: ['./skeleton-checkbox-vehicle.component.scss'],
})
export class SkeletonCheckboxVehicleComponent {}
